import React from 'react';

type ContextOptions<A> = {
  initialValue?: A;
  hookNameOverride?: string;
  contextNameOverride?: string;
};

// TODO: Find a way to be able to use these hooks without being inside of the Context,
// this is useful for components that can work based on values coming from props
// or from the context.
export default function createContext<A extends {} | null>(
  contextName: string,
  { initialValue, hookNameOverride, contextNameOverride }: ContextOptions<A> = {
    hookNameOverride: `use${contextName}Context`,
    contextNameOverride: `${contextName}.Provider`,
  }
) {
  const Context = React.createContext<A | undefined>(initialValue ?? undefined);

  const useContext = () => {
    const contextValue = React.useContext(Context);

    if (contextValue === undefined) {
      throw new Error(
        `${hookNameOverride} must be used inside of a ${contextNameOverride}.`
      );
    }

    return contextValue;
  };

  return [useContext, Context] as const;
}
